import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Lock, ArrowRight, ShieldCheck, Eye, EyeOff } from "lucide-react";
import { API, setSession } from "../../lib/auth";

export default function AdminLogin() {
  const nav = useNavigate();
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.email.includes("@")) return toast.error("Enter valid email");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email: form.email, password: form.password });
      setSession({ token: data.token, user: data.user, tenant: null });
      toast.success("Welcome, Admin");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-gradient-to-br from-[#0F2A1F] via-[#1B4332] to-[#2D6A4F] flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl shadow-2xl p-9 w-full max-w-md">
        <div className="flex items-center gap-2 mb-7">
          <div className="w-11 h-11 rounded-xl bg-[#1B4332] flex items-center justify-center"><ShieldCheck size={22} className="text-white" /></div>
          <div>
            <div className="font-display font-extrabold text-xl text-black">Master Admin</div>
            <div className="text-xs text-black/50">Brivo control panel</div>
          </div>
        </div>
        <h1 className="font-display text-3xl font-extrabold text-black tracking-tight">Sign in</h1>
        <p className="mt-1.5 text-black/60 text-sm">Restricted access — for Brivo platform staff only.</p>
        <form onSubmit={onSubmit} className="mt-7 space-y-4">
          <div>
            <label className="text-sm font-semibold text-black mb-1.5 block">Email</label>
            <div className="flex items-center rounded-xl border border-black/15 focus-within:border-[#1B4332] bg-white px-4">
              <Mail size={16} className="text-black/40" />
              <input data-testid="admin-login-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="flex-1 px-3 py-3 focus:outline-none" placeholder="admin@brivopos.com" />
            </div>
          </div>
          <div>
            <label className="text-sm font-semibold text-black mb-1.5 block">Password</label>
            <div className="flex items-center rounded-xl border border-black/15 focus-within:border-[#1B4332] bg-white px-4">
              <Lock size={16} className="text-black/40" />
              <input data-testid="admin-login-password" type={show ? "text" : "password"} value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="flex-1 px-3 py-3 focus:outline-none" placeholder="••••••••" />
              <button type="button" onClick={() => setShow(!show)} className="text-black/40">
                {show ? <EyeOff size={14} /> : <Eye size={14} />}
              </button>
            </div>
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full mt-2 py-3.5 rounded-xl bg-[#1B4332] text-white font-semibold flex items-center justify-center gap-2 hover:bg-[#133124] disabled:opacity-60">
            {loading ? "Signing in..." : "Sign in"} <ArrowRight size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
